/**
 * Generates a URL path by substituting parameters into the template.
 *
 * @param path - Path template, example: '/users/:id'.
 * @param params - An object with parameters for substitution, example: { id: 123 }.
 * @returns - Final path, example: '/users/123'.
 */
export const generatePath = (
  path: string,
  params: Record<string, string | number>
): string => {
  return Object.keys(params).reduce(
    (currentPath, key) => currentPath.replace(`:${key}`, String(params[key])),
    path
  );
};
